import { z } from 'zod';

export const ROUNDING_MODES = ['none', 'x.99', 'x.95', 'x.90', 'integer'] as const;
/** cost — закупка + наценка; supplier_retail — розничная цена поставщика (наценка не применяется). */
export const PRICE_BASES = ['cost', 'supplier_retail'] as const;
export const RULE_SCOPES = [
  'global',
  'category',
  'brand',
  'product',
  'market',
  'supplier',
] as const;

/** Правило наценки (§9.3). Специфичность: product > brand > supplier > category > market > global. */
export const pricingRuleSchema = z
  .object({
    name: z.string().trim().min(1).max(200),
    scope: z.enum(RULE_SCOPES),
    scopeId: z.uuid().nullable().optional(),
    /** Только для одного прайс-листа (рынка); пусто — для всех. */
    priceListId: z.uuid().nullable().optional(),
    markupPct: z.number().min(0).max(1000),
    markupFixedMinor: z.number().int().min(0).default(0),
    minMarginPct: z.number().min(0).max(1000).optional(),
    maxDiscountPct: z.number().min(0).max(100).optional(),
    rounding: z.enum(ROUNDING_MODES).default('x.99'),
    basis: z.enum(PRICE_BASES).optional(),
    priority: z.number().int().min(0).max(1000).default(0),
    isActive: z.boolean().default(true),
    validFrom: z.iso.datetime().optional(),
    validTo: z.iso.datetime().optional(),
  })
  .refine((r) => (r.scope === 'global') === !r.scopeId, {
    message: 'scopeId is required for every scope except global',
    path: ['scopeId'],
  });
export type PricingRuleRequest = z.infer<typeof pricingRuleSchema>;

export const pricingSettingsSchema = z.object({
  paymentFeePct: z.number().min(0).max(20),
  operatingCostMinor: z.number().int().min(0),
  handlingCostMinor: z.number().int().min(0),
  changeThresholdPct: z.number().min(0).max(1000),
  defaultMinMarginPct: z.number().min(0).max(1000),
});
export type PricingSettingsRequest = z.infer<typeof pricingSettingsSchema>;

export const manualPriceSchema = z.object({
  priceListId: z.uuid(),
  variantId: z.uuid(),
  amountMinor: z.number().int().min(0),
  compareAtMinor: z.number().int().min(0).nullable().optional(),
});
export type ManualPriceRequest = z.infer<typeof manualPriceSchema>;
